import React from 'react'
import { HowItWorksWrapper } from '../affiliate/styles'
import { Header2, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors } from '../../styles/Variables'

const LightsCameraGlam = ({ handleClick }) => {
  const data = {
    Photoshoots:
      'Keep seasoned hair stylists, makeup artists, or nail techs on set to elevate brand shoots, lookbooks, and e-comm photography.',
    'Fashion shows': `Where there's a stage, there's Glamsquad. Make sure each model's hair and makeup perfectly complements their runway look.`,
    'Professional milestones':
      'Get execs and employees camera-ready for headshots, public interviews, TV appearances, and beyond.',
  }

  return (
    <HowItWorksWrapper>
      <div className="how-content">
        <div className="italic-header-container">
          <Header2 align="center">Lights, camera,</Header2>
          &nbsp; &nbsp;
          <Header2 align="center" className="italic">
            glam
          </Header2>
        </div>
        <div className="items-container">
          {Object.keys(data).map((item, i) => (
            <div className="item" key={i}>
              <Text weight={700} fontSize={22}>
                {item}
              </Text>
              <Text weight={400} fontSize={22}>
                {data[item]}
              </Text>
            </div>
          ))}
        </div>
        <div className="get-in-touch-button">
          <Button
            large
            outline
            color={gsColors.black}
            align="center"
            onClick={handleClick}
          >
            Get Started
          </Button>
        </div>
      </div>
    </HowItWorksWrapper>
  )
}

export default LightsCameraGlam
